import { render } from "./404Page.vue?vue&type=template&id=3570694a&scoped=true"
const script = {}

import "./404Page.vue?vue&type=style&index=0&id=3570694a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3570694a"]])

export default __exports__